

































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import SearchService from "@/services/search";
import { IDelegate } from "@/interfaces";
import { LocaleMessage } from "vue-i18n";

@Component({
  computed: {
    ...mapGetters("delegates", ["delegates"]),
    ...mapGetters("ui", ["nightMode"]),
    ...mapGetters("network", ["knownWallets"]),
  },
})
export default class HeaderSearch extends Vue {
  private query: string | null = null;
  private nothingFound = false;
  private searchCount = 0;
  private placeholder: LocaleMessage | string = "Search";

  private delegates: [IDelegate];
  private nightMode: boolean;
  private knownWallets: any;

  get hasInput() {
    return !!this.query;
  }

  public mounted() {
    (this.$refs.search as HTMLInputElement).focus();

    const WIDTH_THRESHOLD = 1024;
    const widthQuery = window.matchMedia(`(max-width: ${WIDTH_THRESHOLD}px)`);

    widthQuery.addListener((e) => this.setMobilePlaceholder(e.matches));

    this.setMobilePlaceholder(window.innerWidth < WIDTH_THRESHOLD);
  }

  private async search() {
    if (!this.query) {
      return;
    }

    this.nothingFound = false;
    this.searchCount = 0;
    this.query = this.query.trim();

    const address = this.findByNameInKnownWallets(this.query);
    if (address) {
      this.changePage("wallet", { address });
      return;
    } else {
      this.updateSearchCount({ message: "No known wallet with that name could be found" });
    }

    const del = this.delegates.find((d) => d.username === this.query!.toLowerCase());
    if (del) {
      this.changePage("wallet", { address: del.address });
      return;
    } else {
      this.updateSearchCount({ message: "No delegate with that username could be found" });
    }

    try {
      const responseAddress = await SearchService.walletByAddress(this.query);
      this.changePage("wallet", { address: responseAddress.address });
      return;
    } catch (e) {
      this.updateSearchCount(e);
    }

    try {
      const responseDelegate = await SearchService.delegateByQuery(this.query.toLowerCase());
      this.changePage("wallet", { address: responseDelegate.address });
      return;
    } catch (e) {
      this.updateSearchCount(e);
    }

    try {
      const responseBlock = await SearchService.blockByQuery(this.query);
      this.changePage("block", { id: responseBlock.id });
      return;
    } catch (e) {
      this.updateSearchCount(e);
    }

    try {
      const responseTransaction = await SearchService.transactionById(this.query);
      this.changePage("transaction", { id: responseTransaction.id });
      return;
    } catch (e) {
      this.updateSearchCount(e);
    }
  }

  private updateSearchCount(err: any) {
    if (err !== null) {
      // tslint:disable-next-line:no-console
      console.log(err.message || err.data.error);
    }

    // Increment counter to keep track of whether we found anything
    this.searchCount += 1;
    if (this.searchCount === 6) {
      // Should match total amount of callbacks
      this.nothingFound = true;
      setTimeout(() => (this.nothingFound = false), 1500);
    }
  }

  private setMobilePlaceholder(showMobile: boolean) {
    if (!this.$i18n) {
      return;
    }
    this.placeholder = showMobile ? this.$i18n.t("SEARCH.PLACEHOLDER.SHORT") : this.$i18n.t("SEARCH.PLACEHOLDER.LONG");
  }

  private changePage(name: string, params: any) {
    this.$router.push({ name, params });
    this.$store.dispatch("ui/setHeaderType", null);
  }

  private findByNameInKnownWallets(name: string) {
    if (name !== null) {
      for (const address in this.knownWallets) {
        if (this.knownWallets[address]) {
          if (name.toLowerCase() === this.knownWallets[address].toLowerCase()) {
            return address;
          }
        }
      }
    }
  }
}
